module.exports = __webpack_public_path__ + "static/media/mastercard.b205c438.svg";